import { render, staticRenderFns } from "./Accordi.vue?vue&type=template&id=3b48b617&scoped=true"
import script from "./Accordi.vue?vue&type=script&lang=js"
export * from "./Accordi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48b617",
  null
  
)

export default component.exports